
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export const getToken = () => {
  return cookies.get('access_token')
}

export const getRefreshToken = () => {
  return cookies.get('refresh_token')
}

export const getUserName = () => {
  return cookies.get('user_name')
}